/* RECOVERY LAB — interactions (vanilla, no deps) */
(function(){
  'use strict';
  var d=document,w=window,root=(w.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var $=function(s,c){return (c||d).querySelector(s)},$$=function(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s))};
  var reduce=w.matchMedia&&w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money=function(c){return new Intl.NumberFormat('es-ES',{style:'currency',currency:(w.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'}).format((c||0)/100)};
  var esc=function(s){return String(s==null?'':s).replace(/[&<>"']/g,function(m){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]})};
  var I={
    plus:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 5v14M5 12h14"/></svg>',
    minus:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 12h14"/></svg>',
    check:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'
  };
  var img=function(u,wd){if(!u)return'';return u+(u.indexOf('?')>-1?'&':'?')+'width='+(wd||200)};
  var mqM=w.matchMedia('(max-width: 989px)');

  /* header */
  var top=$('#rl-top');
  if(top){
    var tick=false;
    var onScroll=function(){top.classList.toggle('is-scrolled',(w.scrollY||0)>40);tick=false};
    w.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(onScroll)}},{passive:true});
    onScroll();
  }

  /* overlays */
  var ov=$('#rl-overlay'),openEl=null;
  function openPanel(el){
    if(!el)return;closePanel();openEl=el;el.classList.add('is-on');
    if(ov)ov.classList.add('is-on');d.body.classList.add('rl-lock');
    if(top)top.classList.add('is-open');
    el.setAttribute('aria-hidden','false');
    var f=el.querySelector('[data-rl-focus]')||el.querySelector('button,a,input');
    setTimeout(function(){f&&f.focus({preventScroll:true})},60);
  }
  function closePanel(){
    if(!openEl)return;openEl.classList.remove('is-on');openEl.setAttribute('aria-hidden','true');
    if(ov)ov.classList.remove('is-on');d.body.classList.remove('rl-lock');
    if(top)top.classList.remove('is-open');openEl=null;
  }
  w.RL={open:openPanel,close:closePanel};
  d.addEventListener('click',function(e){
    var t=e.target.closest('[data-rl-open]');
    if(t){e.preventDefault();var id=t.getAttribute('data-rl-open');openPanel($('#'+id));if(id==='rl-cart')refreshCart();return}
    if(e.target.closest('[data-rl-close]')||e.target===ov){e.preventDefault();closePanel()}
  });
  d.addEventListener('keydown',function(e){if(e.key==='Escape')closePanel()});

  /* predictive search */
  var sIn=$('#rl-search-input'),sRes=$('#rl-search-res'),sT;
  if(sIn&&sRes){
    sIn.addEventListener('input',function(){
      clearTimeout(sT);var q=sIn.value.trim();
      if(q.length<2){sRes.innerHTML='';return}
      sT=setTimeout(function(){
        fetch(root+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
        .then(function(r){return r.json()}).then(function(j){
          var p=(j.resources&&j.resources.results&&j.resources.results.products)||[];
          if(!p.length){sRes.innerHTML='<p style="color:var(--mu);font-size:14px">Sin resultados para “'+esc(q)+'”. Prueba con “luz roja”, “masaje” o “presoterapia”.</p>';return}
          sRes.innerHTML=p.map(function(x){
            return '<a class="rl-sr" href="'+esc(x.url)+'"><img src="'+esc(img(x.image||(x.featured_image&&x.featured_image.url),160))+'" alt="" loading="lazy"><div><b>'+esc(x.title)+'</b><span>'+money(Math.round(parseFloat(x.price)*100))+'</span></div></a>';
          }).join('');
        }).catch(function(){});
      },220);
    });
  }

  /* cart */
  var cartEl=$('#rl-cart');
  var upData=[];try{upData=JSON.parse(($('#rl-up-json')||{}).textContent||'[]')}catch(e){}
  function toast(msg){var t=$('#rl-toast');if(!t)return;t.textContent=msg;t.classList.add('is-on');clearTimeout(t._t);t._t=setTimeout(function(){t.classList.remove('is-on')},2600)}
  function setCount(n,bump){
    $$('[data-rl-count]').forEach(function(c){c.textContent=n;c.classList.toggle('has',n>0);if(bump){c.classList.remove('bump');void c.offsetWidth;c.classList.add('bump')}});
  }
  function pickUps(c){
    var inCart={},types={},maxP=0;
    c.items.forEach(function(i){inCart[i.product_id]=1;if(i.product_type)types[i.product_type]=1;maxP=Math.max(maxP,i.final_price)});
    return upData.filter(function(p){
      return p.available&&!inCart[p.id]&&!(p.type&&types[p.type])&&p.price<=9000&&(!maxP||p.price<maxP);
    }).slice(0,2);
  }
  function renderCart(c){
    if(!cartEl)return;
    setCount(c.item_count);
    var hc=$('[data-rl-cart-n]',cartEl);if(hc)hc.textContent='('+c.item_count+')';
    var body=$('[data-rl-cart-body]',cartEl),ft=$('[data-rl-cart-ft]',cartEl);
    if(!c.item_count){
      body.innerHTML='<div class="rl-cart__empty"><h3>Tu carrito está vacío</h3><p>Encuentra la tecnología de recuperación que encaja con tu entrenamiento.</p><a href="'+root+'collections/all" class="rl-btn rl-btn--ink">Explorar Recovery</a><a href="'+root+'#recuperar" class="rl-link" data-rl-close>¿Qué necesitas para tu recovery?</a></div>';
      ft.hidden=true;return;
    }
    var ups=pickUps(c);
    var upHtml=ups.length?'<div class="rl-cart__up"><h4>Completa tu rutina</h4>'+ups.map(function(p){
      return '<div class="rl-up"><a href="'+esc(p.url)+'"><img src="'+esc(p.img)+'" alt="'+esc(p.title)+'" loading="lazy"></a><div><a href="'+esc(p.url)+'"><b>'+esc(p.title)+'</b></a><span>'+money(p.price)+'</span></div><button type="button" data-rl-quick="'+p.vid+'" aria-label="Añadir '+esc(p.title)+' al carrito">'+I.plus+'</button></div>';
    }).join('')+'</div>':'';
    ft.hidden=false;
    body.innerHTML=c.items.map(function(i){
      var v=(i.options_with_values||[]).filter(function(o){return o.value!=='Default Title'&&o.value!=='Europeo'}).map(function(o){return o.value}).join(' · ');
      var comp=i.original_line_price>i.final_line_price?'<s>'+money(i.original_line_price)+'</s>':'';
      return '<div class="rl-li" data-key="'+esc(i.key)+'"><a class="rl-li__img" href="'+esc(i.url)+'">'+(i.image?'<img src="'+esc(img(i.image,220))+'" alt="'+esc(i.product_title)+'" loading="lazy">':'')+'</a><div><a class="rl-li__t" href="'+esc(i.url)+'">'+esc(i.product_title)+'</a>'+(v?'<div class="rl-li__v">'+esc(v)+'</div>':'')+
        '<div class="rl-li__row"><div class="rl-qty"><button type="button" data-rl-q="-1" aria-label="Restar una unidad">'+I.minus+'</button><span aria-live="polite">'+i.quantity+'</span><button type="button" data-rl-q="1" aria-label="Sumar una unidad">'+I.plus+'</button></div><div class="rl-li__p">'+comp+money(i.final_line_price)+'</div></div><button type="button" class="rl-li__rm" data-rl-rm>Eliminar</button></div></div>';
    }).join('')+upHtml;
    $('[data-rl-sub]',cartEl).textContent=money(c.items_subtotal_price);
    $('[data-rl-total]',cartEl).textContent=money(c.total_price);
    var disc=$('[data-rl-disc-row]',cartEl);
    if(disc){var dv=c.items_subtotal_price-c.total_price;disc.hidden=!(dv>0);if(!disc.hidden)$('[data-rl-disc]',cartEl).textContent='−'+money(dv)}
  }
  function refreshCart(){return fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){renderCart(c);return c})}
  function change(key,q){
    cartEl.classList.add('is-busy');
    return fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:q})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})}).then(function(c){renderCart(c)})
      .catch(function(err){toast((err&&(err.description||err.message))||'No se pudo actualizar el carrito.');refreshCart()})
      .finally(function(){cartEl.classList.remove('is-busy')});
  }
  function added(btn){
    if(!btn)return;
    if(btn._t)clearTimeout(btn._t);
    if(!btn._h)btn._h=btn.innerHTML;
    btn.classList.add('is-added');
    var icon=!btn.textContent.trim()||btn.closest('.rl-up');
    btn.innerHTML=icon?I.check:I.check+'<span>Añadido</span>';
    btn._t=setTimeout(function(){btn.classList.remove('is-added');btn.innerHTML=btn._h;btn._h=null},1800);
  }
  function post(payload){
    var opts={method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}};
    if(payload instanceof FormData)opts.body=payload;else{opts.headers['Content-Type']='application/json';opts.body=JSON.stringify(payload)}
    return fetch(root+'cart/add.js',opts).then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})});
  }
  function add(payload,btn,alsoBtn){
    if(btn)btn.classList.add('is-loading');
    return post(payload)
      .then(function(){return refreshCart()}).then(function(c){
        setCount(c.item_count,true);added(btn);if(alsoBtn&&alsoBtn!==btn)added(alsoBtn);
        setTimeout(function(){openPanel(cartEl)},reduce?0:380);
      })
      .catch(function(err){toast((err&&(err.description||err.message))||'No se pudo añadir. Inténtalo de nuevo.')})
      .finally(function(){if(btn)btn.classList.remove('is-loading')});
  }
  function formData(f){var fd=new FormData(f);Array.from(fd.keys()).forEach(function(k){if(k.indexOf('rl-opt-')===0)fd.delete(k)});return fd}
  if(cartEl){
    try{renderCart(JSON.parse(($('#rl-cart-json')||{}).textContent))}catch(e){}
    cartEl.addEventListener('click',function(e){
      var li=e.target.closest('.rl-li');
      var q=e.target.closest('[data-rl-q]');
      if(q&&li){var n=parseInt($('.rl-qty span',li).textContent,10)+parseInt(q.getAttribute('data-rl-q'),10);change(li.getAttribute('data-key'),Math.max(0,n));return}
      if(e.target.closest('[data-rl-rm]')&&li){li.style.opacity='.4';change(li.getAttribute('data-key'),0)}
    });
  }
  d.addEventListener('click',function(e){
    var b=e.target.closest('[data-rl-quick]');
    if(b){e.preventDefault();add({items:[{id:parseInt(b.getAttribute('data-rl-quick'),10),quantity:1}]},b)}
  });
  d.addEventListener('submit',function(e){
    var f=e.target.closest('form[data-rl-add],form#rl-pform');
    if(!f||!cartEl)return;
    e.preventDefault();
    add(formData(f),f.querySelector('[type=submit]'),w._rlStickyBtn||null);
  });
  d.addEventListener('click',function(e){
    var b=e.target.closest('[data-rl-now]');if(!b)return;
    var f=$('#rl-pform');if(!f)return;e.preventDefault();
    b.classList.add('is-loading');
    post(formData(f)).then(function(){location.href=root+'checkout'})
      .catch(function(err){b.classList.remove('is-loading');toast((err&&(err.description||err.message))||'No se pudo continuar. Inténtalo de nuevo.')});
  });
  w.addEventListener('pageshow',function(e){if(e.persisted){refreshCart();$$('.is-loading').forEach(function(x){x.classList.remove('is-loading')})}});

  /* reveal */
  var rv=$$('.rl-rv');
  if('IntersectionObserver' in w&&!reduce){
    var io=new IntersectionObserver(function(es){es.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
    rv.forEach(function(e){io.observe(e)});
  }else rv.forEach(function(e){e.classList.add('is-in')});

  /* parallax (subtle) */
  var px=$$('[data-rl-px]');
  if(px.length&&!reduce){
    var pt=false;
    var run=function(){
      var vh=w.innerHeight;
      px.forEach(function(el){
        var r=el.parentElement.getBoundingClientRect();
        if(r.bottom<0||r.top>vh)return;
        var k=parseFloat(el.getAttribute('data-rl-px'))||.1;
        var c=(r.top+r.height/2-vh/2);
        el.style.transform='translate3d(0,'+(-c*k).toFixed(1)+'px,0)';
      });pt=false;
    };
    w.addEventListener('scroll',function(){if(!pt){pt=true;requestAnimationFrame(run)}},{passive:true});run();
  }

  /* rails */
  $$('[data-rl-rail]').forEach(function(wrap){
    var rail=$('.rl-rail,.rl-cats',wrap),p=$('.is-prev',wrap),n=$('.is-next',wrap);
    if(!rail||!p||!n)return;
    var upd=function(){p.disabled=rail.scrollLeft<8;n.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-8};
    p.addEventListener('click',function(){rail.scrollBy({left:-rail.clientWidth*.8,behavior:'smooth'})});
    n.addEventListener('click',function(){rail.scrollBy({left:rail.clientWidth*.8,behavior:'smooth'})});
    rail.addEventListener('scroll',upd,{passive:true});w.addEventListener('resize',upd);upd();
  });

  /* tech tabs (legacy section) */
  $$('[data-rl-tabs]').forEach(function(box){
    var tabs=$$('.rl-tab',box),imgs=$$('.rl-tech__vis img',box),cap=$('.rl-tech__cap',box);
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(e){
        if(e.target.closest('a'))return;
        tabs.forEach(function(x,j){x.classList.toggle('is-on',i===j);x.setAttribute('aria-expanded',i===j)});
        imgs.forEach(function(x,j){x.classList.toggle('is-on',i===j)});
        if(cap)cap.textContent=t.getAttribute('data-cap')||'';
      });
    });
  });

  /* tab sets (finder, science) */
  $$('[data-rl-tabset]').forEach(function(box){
    var tabs=$$('[data-tab]',box),panels=$$('[data-panel]',box);
    tabs.forEach(function(t){
      t.addEventListener('click',function(){
        var k=t.getAttribute('data-tab');
        tabs.forEach(function(x){var on=x===t;x.classList.toggle('is-on',on);x.setAttribute('aria-selected',on?'true':'false')});
        panels.forEach(function(p){
          var on=p.getAttribute('data-panel')===k;p.hidden=!on;
          if(on){p.classList.remove('is-shown');void p.offsetWidth;p.classList.add('is-shown');$$('.rl-rv',p).forEach(function(e){e.classList.add('is-in')})}
        });
        var row=t.parentElement;if(row&&row.scrollWidth>row.clientWidth){row.scrollTo({left:t.offsetLeft-row.clientWidth/2+t.clientWidth/2,behavior:reduce?'auto':'smooth'})}
      });
      t.addEventListener('keydown',function(e){
        if(e.key!=='ArrowRight'&&e.key!=='ArrowLeft')return;
        var i=tabs.indexOf(t)+(e.key==='ArrowRight'?1:-1);i=(i+tabs.length)%tabs.length;tabs[i].focus();tabs[i].click();
      });
    });
  });

  /* sticky buy bars: never cover the footer, hidden while a panel is open */
  var ftr=$('.rl-ft');
  function stickyBar(st,shouldShow){
    if(!st)return null;
    var state={ftr:false};
    var apply=function(){var on=shouldShow()&&!state.ftr;st.classList.toggle('is-on',on);d.body.classList.toggle('rl-has-sticky',on)};
    if(ftr&&'IntersectionObserver' in w){new IntersectionObserver(function(es){state.ftr=es[0].isIntersecting;apply()}).observe(ftr)}
    var t=false;w.addEventListener('scroll',function(){if(!t){t=true;requestAnimationFrame(function(){apply();t=false})}},{passive:true});
    w.addEventListener('resize',apply);apply();
    return apply;
  }

  /* product page */
  var pdp=$('[data-rl-pdp]');
  if(pdp){
    var data={};try{data=JSON.parse($('[data-rl-pjson]').textContent)}catch(e){}
    var form=$('#rl-pform',pdp),idIn=form&&form.querySelector('[name=id]');
    var priceEl=$('[data-rl-price]',pdp),cmpEl=$('[data-rl-cmp]',pdp),saveEl=$('[data-rl-save]',pdp),btn=$('[data-rl-atc]',pdp),btnTx=$('[data-rl-atc-tx]',pdp),nowB=$('[data-rl-now]',pdp);
    var st=$('#rl-sticky'),stickyP=$('[data-rl-sticky-price]'),stickyV=$('[data-rl-sticky-var]'),stickyB=st&&$('[data-rl-sticky-btn]',st);
    var track=$('.rl-gal__track',pdp),slides=$$('.rl-gal__s',pdp),ths=$$('.rl-gal__th button',pdp),dots=$$('.rl-gal__dots i',pdp);
    var goSlide=function(i){if(!track||!slides[i])return;track.scrollTo({left:slides[i].offsetLeft,behavior:reduce?'auto':'smooth'})};
    var mark=function(i){ths.forEach(function(t,j){t.classList.toggle('is-on',i===j)});dots.forEach(function(t,j){t.classList.toggle('is-on',i===j)})};
    ths.forEach(function(t,i){t.addEventListener('click',function(){goSlide(i)})});
    if(track){
      var cur=function(){return Math.round(track.scrollLeft/Math.max(1,track.clientWidth))};
      track.addEventListener('scroll',function(){mark(cur())},{passive:true});
      var pv=$('.rl-gal__arr.is-prev',pdp),nx=$('.rl-gal__arr.is-next',pdp);
      pv&&pv.addEventListener('click',function(){goSlide(Math.max(0,cur()-1))});
      nx&&nx.addEventListener('click',function(){goSlide(Math.min(slides.length-1,cur()+1))});
    }
    if(w.matchMedia('(hover: hover) and (pointer: fine)').matches&&!reduce){
      slides.forEach(function(s){
        var im=s.querySelector('img');if(!im)return;
        s.addEventListener('mouseenter',function(){s.classList.add('is-zoom')});
        s.addEventListener('mouseleave',function(){s.classList.remove('is-zoom');im.style.transformOrigin=''});
        s.addEventListener('mousemove',function(e){var r=s.getBoundingClientRect();im.style.transformOrigin=((e.clientX-r.left)/r.width*100).toFixed(1)+'% '+((e.clientY-r.top)/r.height*100).toFixed(1)+'%'});
      });
    }
    var sel=function(){return $$('.rl-opt',pdp).map(function(g){var c=g.querySelector('input:checked');return c?c.value:null})};
    var update=function(user){
      if(!data.variants)return;
      var s=sel();
      var v=data.variants.find(function(x){return x.options.every(function(o,i){return o===s[i]})});
      $$('.rl-opt',pdp).forEach(function(g,gi){
        var lab=g.querySelector('[data-rl-optval]');if(lab)lab.textContent=s[gi]||'';
        $$('input',g).forEach(function(inp){
          var test=s.slice();test[gi]=inp.value;
          var m=data.variants.find(function(x){return x.options.every(function(o,i){return o===test[i]})});
          inp.classList.toggle('is-na',!m||!m.available);
        });
      });
      if(!v){btn.disabled=true;btnTx.textContent='No disponible';if(nowB)nowB.disabled=true;if(stickyB)stickyB.disabled=true;return}
      idIn.value=v.id;
      priceEl.textContent=money(v.price);if(stickyP)stickyP.textContent=money(v.price);
      if(stickyV)stickyV.textContent=s.filter(Boolean).join(' · ');
      if(cmpEl){if(v.compare_at_price>v.price){cmpEl.hidden=false;cmpEl.textContent=money(v.compare_at_price);if(saveEl){saveEl.hidden=false;saveEl.textContent='Ahorra '+money(v.compare_at_price-v.price)}}else{cmpEl.hidden=true;if(saveEl)saveEl.hidden=true}}
      btn.disabled=!v.available;btnTx.textContent=v.available?'Añadir al carrito':'Agotado';
      if(nowB)nowB.disabled=!v.available;if(stickyB)stickyB.disabled=!v.available;
      if(user){
        if(v.featured_media_id){var k=slides.findIndex(function(x){return x.getAttribute('data-mid')==String(v.featured_media_id)});if(k>-1)goSlide(k)}
        var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u.toString());
      }
    };
    $$('.rl-opt input',pdp).forEach(function(i){i.addEventListener('change',function(){update(true)})});
    if($$('.rl-opt',pdp).length)update(false);
    var qIn=$('.rl-buy .rl-qty input',pdp);
    $$('.rl-buy [data-rl-pq]',pdp).forEach(function(b){b.addEventListener('click',function(){qIn.value=Math.max(1,(parseInt(qIn.value,10)||1)+parseInt(b.getAttribute('data-rl-pq'),10))})});
    if(st&&btn){
      stickyBar(st,function(){var r=btn.getBoundingClientRect(),vh=w.innerHeight;var off=r.bottom<60||r.top>vh-70;return mqM.matches?off:r.bottom<60});
      w._rlStickyBtn=stickyB;
      stickyB.addEventListener('click',function(){if(btn.disabled)return;if(form.requestSubmit)form.requestSubmit(btn);else btn.click()});
    }
  }

  /* home sticky: featured product once the hero is passed */
  var hs=$('[data-rl-hsticky]'),hero=$('.rl-hero');
  if(hs&&hero){
    stickyBar(hs,function(){return hero.getBoundingClientRect().bottom<0});
  }

  /* collection sort */
  $$('[data-rl-sort]').forEach(function(s){s.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');location.href=u.toString()})});
})();
